exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#variancesRegister .v--modal-box.v--modal{min-height:440px!important;min-width:685px!important}#variancesRegister .modal__content{overflow-y:hidden!important}#variancesRegister .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-050cfada","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/start/modals/variances/VariancesRegister.vue
// module id = 2102
// module chunks = 0